<template>
  <div
    class="treatment__container"
    :class="{ open: isOpened, 'treatment__container--is-coming-soon': !hasKitsProducts }"
  >
    <treatment-header
      :title="$t('dashboard.label.kits')"
      :icons="kitsIconsConfig"
      :is-opened="isOpened"
      :price="kitsTreatmentPrice"
      :has-recommendation="hasTreatmentRecommendation && hasKitsProducts"
      :is-coming-soon="!hasKitsProducts"
      @section-toggle="toggleSection"
    />
    <slide-down :show="isOpened">
      <div
        slot="slide-body"
        class="treatment__content"
        :class="{ 'treatment__content--opened': isOpened }"
      >
        <template v-for="product in kitsProducts">
          <complementary-care-product
            :key="product.name"
            :product="product"
            :is-active="getIsProductActive(product.name)"
            @toggle-active="updateProduct"
            @update-product="updateProduct($event, true)"
          />
        </template>
      </div>
    </slide-down>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';


import TreatmentHeader from '@/modules/dashboard/components/create-treatment-tab/treatments/TreatmentHeader';
import ComplementaryCareProduct from '@/modules/dashboard/components/create-treatment-tab/treatments/ComplementaryCareProduct';
import SlideDown from '@/modules/dashboard/components/common/SlideDown';

import SectionIcon from '@/modules/dashboard/components/create-treatment-tab/treatments/SectionIcon';

import { types as dashTypes } from '@/modules/dashboard/store/types';
import { isEmpty } from 'lodash';

import {
  CREATE_TREATMENT_SECTION_NAMES,
  TREATMENT_BOTTLE_ICONS_CONFIG
} from '@/modules/dashboard/api/constants';

export default {
  name: 'Kits',
  components: { TreatmentHeader, ComplementaryCareProduct, SlideDown },
  data() {
    return {
      isOpened: false
    };
  },
  computed: {
    ...mapGetters({
      hasTreatmentRecommendation: dashTypes.getters.HAS_TREATMENT_RECOMMENDATION,
      kitsProducts: dashTypes.getters.KITS_PRODUCTS,
      kitsProductsReferences: dashTypes.getters.KITS_PRODUCTS_REFERENCES,
      kitsTreatment: dashTypes.getters.KITS_TREATMENT,
      kitsTreatmentPrice: dashTypes.getters.KITS_TREATMENT_PRICE
    }),
    kitsIconsConfig() {
      return this.kitsProductsReferences.map(reference => {
        const isProductActive = false;

        return new SectionIcon(TREATMENT_BOTTLE_ICONS_CONFIG[reference], isProductActive);
      });
    },
    hasKitsProducts() {
      return !isEmpty(this.kitsProducts);
    }
  },
  methods: {
    ...mapActions({
      toggleComplementaryCareProduct: dashTypes.actions.TOGGLE_COMPLEMENTARY_CARE_PRODUCT,
      updateComplementaryCareProduct: dashTypes.actions.UPDATE_COMPLEMENTARY_CARE_PRODUCT
    }),
    toggleSection() {
      if (this.hasKitsProducts) {
        this.isOpened = !this.isOpened;
      }
    },
    getIsProductActive(product) {
      return this.kitsTreatment.includes(product);
    },
    async updateProduct(product, isUpdate = false) {
      const actionParams = {
        ...product,
        section: CREATE_TREATMENT_SECTION_NAMES.KITS,
        isUpdate
      };

      if (isUpdate) {
        await this.updateComplementaryCareProduct(actionParams);

        return;
      }

      await this.toggleComplementaryCareProduct(actionParams);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/treatment/create-treatment-shared';
@import '../../../../../assets/scss/helpers/colors';

.treatment__content {
  padding: 20px;
}

@media (max-width: 767px) {
  .treatment__content {
    padding: 15px 5px;
    background-color: $dim-background;
  }
}
</style>
